import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'

export const getNonBankCapitalAndLeverageThunk = createAsyncThunk(
  'financialAnalysis/NonBank/getBankCapitalAndLeverage',
  async (data, { rejectWithValue }) => {
    const response = await FinancialAnalysisService.getCapitalAndLeverage(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadNonBankCapitalAndLeverage = createAsyncThunk(
  'financialAnalysis/NonBank/downloadBankCapitalAndLeverage',
  async (data) => {
    const response = await FinancialAnalysisService.downloadCapitalAndLeverage(
      data,
    )
    handleExport(response.data, response.filename)
  },
)
